/**
 * FlashMessage.js
 * A simple message info bar.
 *
 * @class   FlashMessage
 * @author  Yevgeniy Rokhlin
 *
 */

import React from 'react';
import ClassNames from 'classnames';
import Paper from 'components/paper/Paper';

export default React.createClass({



    displayName: "FlashMessage",

    propTypes: {
        type: React.PropTypes.string.isRequired, // success, error, alert, notice
        text: React.PropTypes.string.isRequired, // body text
        animated: React.PropTypes.bool,
        zIndex: React.PropTypes.number, // Optional, if you want the FlashMessage to animate behind the item on top of it.
        depth: React.PropTypes.number,
        key: React.PropTypes.number,
        onMessageClick: React.PropTypes.func,
        closeCustomFontIcon: React.PropTypes.string

    },

    getDefaultProps() {
        return {
            depth: 1,
            closeCustomFontIcon: 'fa-times-circle'
        };
    },

    render() {

        // Paper CSS classes added for the depth propr, because calling Paper directly
        // was causing some really funky z-index problems, and screwed with animation.
        let classes = ClassNames(
            'lui-flash-message',
            'lui-paper',
            `lui-paper-z-depth-${this.props.depth}`,
        {
            'lui-is-clickable' : this.props.onMessageClick,
            'lui-is-animated': this.props.animated,
            'success': this.props.type === 'success',
            'error': this.props.type === 'error',
            'alert': this.props.type === 'alert',
            'notice': this.props.type === 'notice'
        });

        let style = {
            zIndex: this.props.zIndex
        };

        return (
            <div ref="flashMessage" key={this.props.key} onClick={this._onMessageClick} className={classes} style={style} >
                <div>{this.props.text}</div>
                <div ref="flashMessageClose" className="lui-flash-message-close">
                    <i className={`fa ${this.props.closeCustomFontIcon}`} />
                </div>
            </div>
        );
    },

    // Destroys the virtual node and the dom node
    dismiss() {

        if(this.props.onDismiss) {
            return this.props.onDismiss(this.props.uuid);
        }

        let node = React.findDOMNode(this);
        React.unmountComponentAtNode(node);
        node.parentElement.removeChild(node);

    },

    _onMessageClick(e) {
        // If the click target is the close button, call dismiss()
        if (e.target.className === `fa ${this.props.closeCustomFontIcon}`) {
            this.dismiss();
        };

        // If the click target is not the close button and onMessageClick prop is assign, call the custom function.
        if (this.props.onMessageClick && e.target.className !== `fa ${this.props.closeCustomFontIcon}`) {
            this.props.onMessageClick();
        };
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/flash-message/FlashMessage.js
 **/